import { render, staticRenderFns } from "./FreeBoxList.vue?vue&type=template&id=0b823484&scoped=true&"
import script from "./FreeBoxList.vue?vue&type=script&lang=ts&"
export * from "./FreeBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./FreeBoxList.vue?vue&type=style&index=0&id=0b823484&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b823484",
  null
  
)

export default component.exports